export enum PROPOSTA_CONFIRMACAO_VALORES_ACAO {
	CONFIRMAR,
	SALVAR
}
